'use strict';

exports.__esModule = true;
exports.resolvePayload = resolvePayload;

var _merge = require('./merge');

function resolvePayload(payload) {
  return (Array.isArray(payload) ? payload : []).reduce(function (acc, curr) {
    acc.tags = (0, _merge.merge)(acc.tags, curr && curr.tags);
    return acc;
  }, { tags: [] });
}